<script setup="">
import { ArrowRightIcon } from "lucide-vue-next";
import { computed } from "vue";

import SimpleInput from "@/Components/Form/SimpleInput.vue";
import ToggleSwitch from "@/Components/Form/ToggleSwitch.vue";

import { Link } from "@inertiajs/vue3";

const props = defineProps({
  campaign: {
    type: Object,
    required: true
  },
  update: {
    type: Function,
    required: true
  }
});

const kakaoChannelEnabled = computed({
  get: () => props.campaign.settings?.quick_links?.kakao_channel?.enabled,
  set: (value) => props.update("settings.quick_links.kakao_channel.enabled", value)
});

const kakaoChannelId = computed({
  get: () => props.campaign.settings?.quick_links?.kakao_channel?.id,
  set: (value) => props.update("settings.quick_links.kakao_channel.id", value)
});

const kakaoOpenChatEnabled = computed({
  get: () => props.campaign.settings?.quick_links?.kakao_open_chat?.enabled,
  set: (value) => props.update("settings.quick_links.kakao_open_chat.enabled", value)
});

const kakaoOpenChatId = computed({
  get: () => props.campaign.settings?.quick_links?.kakao_open_chat?.id,
  set: (value) => props.update("settings.quick_links.kakao_open_chat.id", value)
});
</script>

<template>
  <div class="space-y-4">
    <div class="flex items-center justify-between border-b py-2">
      <div class="text-sm+ font-bold">댓글</div>
      <div>
        <Link :href="route('app.pages.index', campaign.team)" class="flex-center text-sm text-400 hover:text-800">
          <span>페이지별 설정</span>
          <ArrowRightIcon class="ml-1 h-4 w-4" />
        </Link>
      </div>
    </div>
    <!--end::item-->
    <div>
      <div class="flex items-center justify-between py-2">
        <div class="text-sm+ font-bold">카카오채널</div>
        <div>
          <ToggleSwitch v-model="kakaoChannelEnabled" size="xs" />
        </div>
      </div>
      <div>
        <SimpleInput
          v-model="kakaoChannelId"
          input-class="border-x-0 border-t-0 border-b rounded-none md:rounded-none bg-transparent dark:bg-transparent pl-36"
          icon-class="pl-0"
          placeholder="_aLvxlG"
        >
          <template #icon>
            <span class="text-sm">https://pf.kakao.com/</span>
          </template>
        </SimpleInput>
      </div>
    </div>
    <!--end::item-->
    <div>
      <div class="flex items-center justify-between py-2">
        <div class="text-sm+ font-bold">카톡오픈톡</div>
        <div>
          <ToggleSwitch v-model="kakaoOpenChatEnabled" size="xs" />
        </div>
      </div>
      <div>
        <SimpleInput
          v-model="kakaoOpenChatId"
          input-class="border-x-0 border-t-0 border-b rounded-none md:rounded-none bg-transparent dark:bg-transparent pl-44"
          icon-class="pl-0"
          placeholder="abcdefg"
        >
          <template #icon>
            <span class="text-sm">https://open.kakao.com/o/</span>
          </template>
        </SimpleInput>
      </div>
    </div>
    <!--end::item-->
  </div>
</template>
